import { render, staticRenderFns } from "./PlanChart.vue?vue&type=template&id=2c4c5cdd&scoped=true"
import script from "./PlanChart.vue?vue&type=script&lang=js"
export * from "./PlanChart.vue?vue&type=script&lang=js"
import style0 from "./PlanChart.vue?vue&type=style&index=0&id=2c4c5cdd&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c5cdd",
  null
  
)

export default component.exports